<div class="background">
    <div class="row pt-4" style="display: flex; flex-direction: columnn; gap: 25px; text-align: center;">
      <span>
        <img height="50" src="../../../assets/images/rondeivu-logo-transparent-background.png" alt="Rondeivu Logo">
      </span>
      <span style="font-size: 50px; line-height: 60px; font-weight: bold; color: #333">
        Oops!
        There was an error!</span>
      <span class="pt-2" style="font-size: larger;" *ngIf="!!message">
        {{message}}
      </span>

      <span>
        <button mat-button class="pt-2" color="primary" (click)="goBack()">Go Back</button>
      </span>
    </div>
</div>
  